/**
 * Parse a WebVTT Empty Sample Box from an IsoView
 *
 * @returns A parsed WebVTT Empty Sample Box
 *
 * @group ISOBMFF
 *
 * @beta
 */
export function vtte() {
    // Nothing should happen here.
    return {};
}
;
//# sourceMappingURL=vtte.js.map